import { render, staticRenderFns } from "./whats_new_for_you_menu_item.vue?vue&type=template&id=43764992"
import script from "./whats_new_for_you_menu_item.vue?vue&type=script&lang=js"
export * from "./whats_new_for_you_menu_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports